// Polyfills for Node.js globals in browser environment
import { Buffer } from 'buffer';

// Ensure Buffer is available globally
if (typeof window !== 'undefined') {
  (window as any).Buffer = Buffer;
  (window as any).global = window;
  
  // Also ensure process is available
  if (!(window as any).process) {
    (window as any).process = require('process/browser');
  }

  // CommonJS compatibility - only set if not already defined
  if (typeof (window as any).exports === 'undefined') {
    (window as any).exports = {};
  }
  if (typeof (window as any).module === 'undefined') {
    (window as any).module = { exports: (window as any).exports };
  }
}

// Export for explicit imports
export { Buffer };
